import {
  attributesToProps,
  DOMNode,
  domToReact,
  Element,
  HTMLReactParserOptions,
} from "html-react-parser";

export const options: HTMLReactParserOptions = {
  replace: (domNode) => {
    const node = domNode as Element;
    if (!node.attribs) return;

    const props = attributesToProps(node.attribs);
    const theChildren = node.children as DOMNode[];

    if (node.name === "a") {
      return (
        <a
          {...props}
          rel="noopener noreferrer"
          target="_blank"
          className="text-[#1e88e5]"
        >
          {domToReact(theChildren, options)}
        </a>
      );
    }

    if (node.name === "ul") {
      return (
        <ul className="list-disc mb-4 pr-10 mt-4" {...props}>
          {domToReact(theChildren, options)}
        </ul>
      );
    }

    if (node.name === "li") {
      return <li {...props}>{domToReact(theChildren, options)}</li>;
    }
  },
};
